module.exports = "h1 {\n    text-align: center;\n}\n\n.centered {\n    display: block;\n    margin: 0 auto;\n}\n\n.logo {\n    max-width: 300px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/not-found/not-found.component.css
// module id = ./src/app/core/components/not-found/not-found.component.css
// module chunks = main